export default __webpack_public_path__ + "static/media/annotations.a9bcbebc.png";